/* eslint-disable */
/*
Purpose: displays images for a user, if specified, or images for all the current user follows. toggle grid vs list mode

Notes:
Like other RecyclingScrollView pages, the main data is loaded directly via fetch.
Keep in mind that there could be other copies of this screen in the navigation stack.
When in list (as opposed to grid) mode, there needs to be an api call to load the full Post details (10 at a time max)
This might best be accomplished with Sagas.
Note the visibility property, this need to be more sophisticated as we want all copies of this screen
on the navigationstack to show just pastel squares aside from the one that is on top.
This is to try and reduce the amount of memory used, and reduce the likelyhood of a crash.

Started work on making this a bit more generic, as it can be used in other places.
Overriding header and other functions will allow this code to work elsewhere.
*/

import React, { Component } from 'react'
import {
  Image,
  TouchableOpacity,
  View,
  Text,
  FlatList,
  ActivityIndicator,
  Dimensions,
  RefreshControl
} from 'react-native'

import { KargoeConfig } from '../Config/AppConfig'

import { connect } from 'react-redux'
import { NavigationActions } from 'react-navigation';

import UserActions from '../Redux/UserRedux'
import PostsActions from '../Redux/PostsRedux'
import PostDetailsActions from '../Redux/PostDetails2Redux'
import LoveActions from '../Redux/LoveRedux'
import CreatePostActions from '../Redux/CreatePostRedux'
import OrderActions from '../Redux/OrderRedux'
import FollowActions from '../Redux/FollowRedux'
import SwiperActions from '../Redux/SwiperRedux'
import ActionSheetActions from '../Redux/ActionSheetRedux'
import CustomMainNavBar from '../Components/CustomMainNavBar'
import SectionHeaderFollow from '../Components/SectionHeaderFollow'
import SectionHeader from '../Components/SectionHeader'

import HeaderAvatarComponent from '../Components/HeaderAvatarComponent'
import StaticInforComponent from '../Components/StaticInforComponent'
import PostLinkComponent from '../Components/PostLinkComponent'

// Styles
// import styles from './Styles/PostWallScreenStyle'
import styles from './Styles/ProfileWallV2ScreenStyle'
import Colors from '../Themes/Colors'
import Images from '../Themes/Images'
import { SvgBlockUser } from '../Components/SvgComponent'
import { getAvatar, convertBio, showError, BBCodesToPlainText } from '../Lib/utils'
import AlertMessage from '../Components/AlertMessage'

import PostWallBase from './PostWallBase'
import I18n from "i18n-js"

const { width, height } = Dimensions.get('window')
const origScreenWidth = width
let screenWidth = width

// NOTE: override renderHeader or other parts to use as you wish

const BlockColor = '#09cdcc'
const UnblockColor = '#bd202c'
class ProfileWallV2Screen extends PostWallBase {
  constructor(args) {
    // super(args)
    console.tron.display({
      name: 'ProfileWallV2Screen',
      preview: 'args',
      value: {
        args: args
      }
    })

    let factor = window.mainViewWidthFraction ? window.mainViewWidthFraction : 1
    screenWidth = origScreenWidth * factor
    
    const { postId } = args.navigation.state.params
    // see this.getScreenUserId
    const screenUserId = args.navigation.state.params.userId ? args.navigation.state.params.userId : args.auth.user.UserId

    const thenOpenPostView = args.navigation.state.params.thenOpenPostView // optional
    const commentTimeStamp = args.navigation.state.params.TimeStamp // optional

    console.log("PostWallV2Screen thenOpenPostView = " + thenOpenPostView + " commentTimeStamp = " + commentTimeStamp)

    // initialRowIndex = -1
    const newArgs = Object.assign({}, args, {
      initialMode: 'list',
      initialPostId: postId ? postId : null,
      isProfile: true,
      isMyProfile: screenUserId == args.auth.user.UserId,
      thenOpenPostView: thenOpenPostView, // bool, true = after scrolling to a post, we open the post view for it
      commentTimeStamp: commentTimeStamp // optional time stamp of exact comment to scroll to
    })

    super(newArgs) // cannot use this before here
    this.screenNavKey = args.navigation.state.key // visible?
    this.HomeWall = false
    this.ProfileWall = true
    this.calledLoadMore = false
    this.headerRowHeight = this.state.isMyProfile ? 188 : 248

    this.readUserInfo()
    if (this.getScreenUserId() !== this.props.auth.user.UserId) {
      this.props.getBockUser({ userId: this.props.auth.user.UserId })
    }

    this.screenCreated = new Date().getTime()
  }

  loadMoreDataUrl( ) {
    const length = 100
    const userId = this.state.userId ? this.state.userId : ''
    const start = this.state.start && !this.state.refreshing ? this.state.start : ''
    const extra = start == '' && this.initialPostId != null ? "&untilPostId=" + this.initialPostId : ''
    const url = `${KargoeConfig.baseUrlAPI}v1/post?UserId=${userId}&limit=${length}&start=${start}&miniHints=true${extra}`

    const options = {
      method: 'GET',
      headers: { Authorization: 'Token ' + this.props.auth.token }
    }
    return { url: url, options: options }
  }

  loadMoreVidDataUrl ( ) {
    const userId = this.state.userId? this.state.userId: ''
    const start = (this.state.vidStart && !this.state.refreshing)? this.state.start: ''
    const url = `${KargoeConfig.baseUrlAPI}v1/post?UserId=${userId}&limit=100&start=${start}&videos=true`
    const options = {
      method: 'GET',
      headers: { Authorization: `Token ${this.props.auth.token}` }
    }
    return {
      url: url,
      options: options
    }
  }

  componentWillReceiveProps(nextProps) {
		// console.log(`ProfileWallV2Screen componentWillReceiveProps`)
    super.componentWillReceiveProps(nextProps)
    if (nextProps.blockUserData != null && this.props.blockUserData !== nextProps.blockUserData) {
      if (nextProps.blockUserData.length > 0) {
        const isBlockUser = nextProps.blockUserData.find((users, index) => {
          return this.props.navigation.state.params.userId == users.UserId
        })
        this.setState({ isBlockUser: isBlockUser !== undefined ? true : false })
      } else {
        this.setState({ isBlockUser: false })
      }
    }
/*
    if (this.props.user !== nextProps.user && nextProps.user !== null && typeof nextProps.user.UserIsFollowing != 'undefined' && this.state.isUserFollow != nextProps.user.UserIsFollowing) {
			console.log(`ProfileWallV2Screen componentWillReceiveProps UserIsFollowing`)
      this.setState({ isUserFollow: nextProps.user.UserIsFollowing })
    }
*/    
    if (nextProps.user && typeof nextProps.user.State != 'undefined' && nextProps.user.UserId == this.state.userId) {
			// console.log(`ProfileWallV2Screen componentWillReceiveProps profileUser`)
      this.setState({profileUser: nextProps.user, haveProfileUser: true, isUserFollow: nextProps.user.UserIsFollowing})
    }
  }

  componentWillMount ( ) {
    this.props.readSelf(this.props.auth.user.UserId)
    super.componentWillMount( )
    this.subs = [
      this.props.navigation.addListener('didFocus', ( ) => {
        this.setState({ focused : true })
        this.focused = true // for video horiz allowig (see post wall base)
        console.log('component did come into focus')
        console.log(`navigation userid: ${this.props.navigation.state.params.userId}, state user id: ${this.state.userId}, props mapped user userid: ${this.props.user?this.props.user.UserId:'false'}`)
        if( typeof this.props.navigation.state.params.userId === 'undefined'
          && this.state.userId != (this.props.user?this.props.user.UserId:false) )
          this.readUserInfo ( )
      })
    , this.props.navigation.addListener('willBlur', ( ) => {
        this.setState({ focused : false })
        this.focused = false // for post wall base
        console.log('component will blur out of focus')
      })
    ]
  }
  componentWillUnmount ( ) {
    super.componentWillUnmount( )
    console.log('profile wall destructor')
    console.log(`navigation userid: ${this.props.navigation.state.params.userId}, state user id: ${this.state.userId}, props mapped user userid: ${this.props.user?this.props.user.UserId:'false'}`)
    this.subs.forEach(sub => sub.remove( ))
  }

  getScreenUserId ( ) {
    return this.props.navigation.state.params.userId ? this.props.navigation.state.params.userId:
      ((this.state&&this.state.userId)?this.state.userId:this.props.auth.user.UserId)
  }

  readUserInfo = () => {
    this.props.readUser(this.getScreenUserId())
  }

  gotoEditProfile = () => {
    if (this.getScreenUserId() == this.props.auth.user.UserId) {
      this.props.navigation.navigate('editProfile', { refreshProfile: this.refreshProfile })
    }
    else { // if other user, make the photo bigger in a modal
      this.setState({modalLargeAvatarOn: true})
    }
  }

  refreshProfile = () => {
    this.readUserInfo()
    console.log("refresh profile in profile wall v2 screen")
    this.setState({recyclerListKey: this.state.recyclerListKey + 1})
  }

  blockUser = () => {
    if (this.state.isBlockUser)
      this.yesPerformBlock(false) // unblock without confirming
    else
      this.alert.showModal()
/*
    this.props.blockUser({
      isBlockUser: !this.state.isBlockUser,
      userId: this.props.auth.user.UserId,
      blockUserId: this.getScreenUserId()
    })
    this.setState({
      isBlockUser: !this.state.isBlockUser
    })
*/
  }

  yesPerformBlock(fromDialog = true) {
    console.tron.log(`yesPerformBlock`)
    if (fromDialog)
      this.alert.hideModal()
    this.props.blockUser({
      isBlockUser: !this.state.isBlockUser,
      userId: this.props.auth.user.UserId,
      blockUserId: this.getScreenUserId()
    })
    this.setState({
      isBlockUser: !this.state.isBlockUser
    })
  }

  postLink() {
    // const now = Date.now()
    // const delta = Math.floor(Date.now() / 10) // every 10 seconds
    return <PostLinkComponent
      key={`post_link`}
      viewMode={this.state.viewMode}
      toogleGridView={this.clickMode}
      nav={this.props.navigation}
      onRefresh={this._onRefresh.bind(this)} />
  }

  getMyProfileBar = () => {
    const user = this.state.profileUser // this.props.user
    const haveProfileUser = this.state.haveProfileUser
    return (
      <CustomMainNavBar
        key={'nav_container'}
        leftButtonTitle={!this.props.canGoBack ? '' : 'back'}
        onLeftPress={this._onPressBack}
        rightButtonTitle={'home'}
        onRightPress={this.onHomePress}
        online={haveProfileUser ? user.Online : null}
        title={haveProfileUser || user.Username != this.props.auth.user.Username ? user.Username : ' '}
        onTitlePress={this.onTitlePress}
      />
    )
  }
  onHomePress = ( ) => {
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'home', params: { isScroll : true } })]
    }))
  }
  getBlockUserView_UNUSED=()=>{
		// containerStyle={styles.button} onPress={this.state.isUserFollow === true ? this.onUnfollowUser : this.onFollowUser} />
		return(
      this.props.blockUserData ? <View style={styles.inputView}>
      <View key={'profile_buttons'} style={styles.buttonContainer}>
        <SectionHeaderFollow text={this.state.isUserFollow === true ? (' ' + I18n.t('followersProfile.followingLC') + ' '): ' ' + I18n.t('followersProfile.followLC') + ' '}
          style={styles.buttonText}
          containerStyle={styles.button, Platform.OS == 'web' ? {width: 200}: {}} onPress={() => {
						if (this.state.isUserFollow)
							this.onUnfollowUser()
						else
							this.onFollowUser()
					} } />
        <SectionHeader text={' ' + I18n.t('followersProfile.message') + ' '} style={styles.buttonText} containerStyle={[styles.button, styles.buttonRight]} onPress={this.messageAction} />
      </View>
      <TouchableOpacity
        hitSlop={{left: 10, right: 10, top: 10, bottom: 10}}
        onPress={this.blockUser}
        style={styles.tconContainer}>
        <SvgBlockUser tinColor={this.state.isBlockUser == true ? UnblockColor: BlockColor} size={30} />
      </TouchableOpacity>
      </View> : null
    )
  }

  getBlockUserView=()=>{
		// containerStyle={styles.button} onPress={this.state.isUserFollow === true ? this.onUnfollowUser : this.onFollowUser} />
		return(
      this.props.blockUserData ?
      <View style={styles.inputView}>
        <View key={'profile_buttons'} style={styles.buttonContainer}>
          <SectionHeaderFollow text={this.state.isUserFollow === true ? I18n.t('followersProfile.followingLC') : I18n.t('followersProfile.followLC')}
            style={styles.buttonText}
            containerStyle={styles.button} onPress={() => {
              if (this.state.isUserFollow)
                this.onUnfollowUser()
              else
                this.onFollowUser()
            } } />
          <SectionHeader text={I18n.t('followersProfile.message')} style={styles.buttonText} containerStyle={[styles.button, styles.buttonRight]} onPress={this.messageAction} />
        </View>
        <TouchableOpacity
          hitSlop={{left: 10, right: 10, top: 10, bottom: 10}}
          onPress={this.blockUser}
          style={styles.tconContainer}>
          <SvgBlockUser tinColor={this.state.isBlockUser == true ? UnblockColor: BlockColor} size={30} />
        </TouchableOpacity>
      </View> : 
      <View style={styles.inputView}>
        <View key={'profile_buttons'} style={styles.buttonContainer}>
          <SectionHeaderFollow text={I18n.t('followersProfile.followingLC')} style={styles.buttonText} containerStyle={styles.button}/>
          <SectionHeader text={I18n.t('followersProfile.message')} style={styles.buttonText} containerStyle={[styles.button, styles.buttonRight]} />
        </View>
        <TouchableOpacity
          hitSlop={{left: 10, right: 10, top: 10, bottom: 10}}
          style={styles.tconContainer}>
          <SvgBlockUser tinColor={this.state.isBlockUser == true ? UnblockColor: BlockColor} size={30} />
        </TouchableOpacity>
      </View>
    )
  }

  getFollowView=()=>{
    const isMyProfile = this.getScreenUserId() == this.props.auth.user.UserId
    const user = this.state.profileUser // this.props.user
    const haveProfileUser = this.state.haveProfileUser
    return (  <StaticInforComponent
      style={styles.staticInfor}
      isMyProfile={!isMyProfile}
      onFollowerPress={this.onFollowerPress}
      onFollowingPress={this.onFollowingPress}
      views={haveProfileUser && user.NumViews}
      loves={haveProfileUser && user.NumLikes}
      followers={haveProfileUser && user.NumFollowers}
      following={haveProfileUser && user.NumFollowing}
      onPress={this.clickMode}
      viewMode={this.state.viewMode} />)
  }

  getUserProfileView = () => {
    const user = this.state.profileUser // this.props.user
    const haveProfileUser = this.state.haveProfileUser
    const uri = { uri: getAvatar(this.state.userId || '') }
    return (
      <View key={'profile_wrapper'} style={{ marginTop: 13, marginBottom: 15 }}>
        <HeaderAvatarComponent
          onPressAvatar={this.gotoEditProfile}
          online={haveProfileUser && user.Online}
          text={haveProfileUser && BBCodesToPlainText(user.Bio)}
          uri={uri} />
    </View>
    )
  }

  getMyProfileView = () => {
    const user = this.state.profileUser // this.props.user
    const haveProfileUser = this.state.haveProfileUser
    const isMyProfile = this.getScreenUserId() == this.props.auth.user.UserId
    const progress = this.props.updatePostProgress
    const uri = { uri: getAvatar(this.state.userId || '') }
    console.tron.log(`getMyProfileView progress: ${progress}`)
    return (
      <View key={`profile_wrapper`} style={{ marginTop: 13, marginBottom: 15 }}>
        <HeaderAvatarComponent
          onPressAvatar={this.gotoEditProfile}
          online={haveProfileUser && user.Online}
          text={haveProfileUser && BBCodesToPlainText(user.Bio)}
          uri={uri} />
        <StaticInforComponent
          style={styles.staticInfor}
          isMyProfile={!isMyProfile}
          onFollowerPress={this.onFollowerPress}
          onFollowingPress={this.onFollowingPress}
          views={haveProfileUser && user.NumViews}
          loves={haveProfileUser && user.NumLikes}
          followers={haveProfileUser && user.NumFollowers}
          following={haveProfileUser && user.NumFollowing}
          onPress={this.clickMode}
          viewMode={this.state.viewMode} />
      </View>
    )
  }

  renderHeader(makeTransparentHeader, progress) {
    const { isBlockUser } = this.state
    const profileUserId = this.state.userId
    const loggedInUserId = this.props.auth.user.UserId

    const uri = { uri: getAvatar(profileUserId || '') }
    const isMyProfile = this.getScreenUserId() == this.props.auth.user.UserId
    // console.tron.log('isMyProfile: ' + (isMyProfile ? 'true' : 'false'))

    return (
      isMyProfile ? this.getMyProfileView() : this.getUserProfileView()
    )
  }
} // ProfileWallV2Screen


const mapStateToProps = state => {
  return {
    heightBio:state.readmore.height,
    blockUserData: state.user.blockUserData,
    successBlockUser: state.user.blockUser,
    updatePostSuccess: state.posts.updatePostSuccess,
    updatePostProgress: state.posts.updatePostProgress,
    updatePost: state.posts.updatePost,
    deletePost: state.posts.deletePost,
    auth: state.auth,
    exchangeRates: state.user.exchangeRates,
    user: state.user.otherUser,
    currentUser: state.user,
    posts: state.posts,
    postdetails: state.postdetails,
    postCreation: state.postCreation,
    order: state.order,
    love: state.love,
    follow: state.follow,
    options: state.postCreation.basePostWallOptions,
    shoppableCheckout: state.shoppable ? state.shoppable.checkout : false,
    nav: state.nav,
    canGoBack: state.nav.routes.length > 1,
    transparentPanels: false,
    swiperIndex: state.swiper.indexChange,
    musicSettings: state.swiper.music,
		muted: state.swiper.music.muted,
    comments: state.posts.comments,
		slowNetwork:  state.auth.user && (state.auth.user.ApplicationOptions & 2) == 2
  }
}

const mapDispatchToProps = dispatch => ({
  showPayPal: isShow => dispatch(ActionSheetActions.paypalPopup(isShow)),
  blockUser: data => dispatch(UserActions.blockUserRequest(data)),
  getBockUser: data => dispatch(UserActions.getBlockUserRequest(data)),
  deletePostAction: data => dispatch(PostsActions.deletePostRequest(data)),
  readUser: UserId => dispatch(UserActions.readOtherRequest(UserId)),
  readSelf: UserId => dispatch(UserActions.readRequest(UserId)),
  reportPost: data => dispatch(PostsActions.reportPostRequest(data)),
  readPosts: userId => dispatch(PostDetailsActions.posts2Request(userId)),
  repost: (postId, post) => dispatch(CreatePostActions.createRepost(postId, post)),
  quickLove: (postId, relationship) => dispatch(LoveActions.loveInsist({ postId : postId, relationship : relationship })),
  lovePost: postId => dispatch(LoveActions.loveRequest(postId)),
  unlovePost: postId => dispatch(LoveActions.unloveRequest(postId)),
  followUser: (userId, user2Id) => dispatch(FollowActions.followRequest(userId, user2Id)),
  unFollowUser: (userId, user2Id) => dispatch(FollowActions.unfollowRequest(userId, user2Id)),
  tagDetails: (postId) => dispatch(OrderActions.orderTags(postId)),
  orderPreflight: (postId, itemId) => dispatch(OrderActions.orderPreflight(postId, itemId)),
  changeIndex: (index) => dispatch(SwiperActions.changeIndex(index)),
  setCameraLockout: (setting) => dispatch(SwiperActions.setCameraLockout(setting)),
  postComment: (params) => dispatch(PostsActions.postCommentRequest(params)),
  getPostComments: params => dispatch(PostsActions.getPostCommentsRequest(params)),
  setForceRefreshIndex: (setting) => dispatch(SwiperActions.setForceRefreshIndex(setting)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileWallV2Screen)
